import { useCallback, useEffect, useRef } from 'react';
import { overlay } from 'overlay-kit';
import { useUser } from '@/lib/auth';
import { CookieManager } from '@/shared/cookies';
import { markPromotionModalShown, wasPromotionModalShown } from '@/shared/features/promotion-modal-state';
import { ClassroomPromotionModal } from '../components/ClassroomPromotionModal';
const CLASSROOM_PROMOTION_COOKIE = 'classroom_promotion_dismissed';
export const useClassroomPromotionModal = (triggeredOn = 'classroom_auto_promotion') => {
  const {
    isInitialized,
    user
  } = useUser();
  const canShowToAudience = !!user && user.type?.toLowerCase() !== 'student';
  const hasOpenedRef = useRef(false);
  const isDismissed = useCallback(() => {
    const cookieManager = new CookieManager(CLASSROOM_PROMOTION_COOKIE);
    return cookieManager.has();
  }, []);
  const dismiss = useCallback(() => {
    const cookieManager = new CookieManager(CLASSROOM_PROMOTION_COOKIE, {
      expires: new Date('2099-12-31')
    });
    cookieManager.set('true');
  }, []);
  const openModal = useCallback(() => {
    overlay.open(({
      close,
      isOpen
    }) => <ClassroomPromotionModal isOpen={isOpen} triggeredOn={triggeredOn} onClose={() => {
      dismiss();
      close();
    }} onDismiss={dismiss} />);
  }, [dismiss, triggeredOn]);
  const shouldShowModal = useCallback(() => {
    if (!isInitialized) return false;
    if (!canShowToAudience) return false;
    if (isDismissed()) return false;
    if (wasPromotionModalShown()) return false;
    return true;
  }, [isInitialized, canShowToAudience, isDismissed]);
  useEffect(() => {
    if (hasOpenedRef.current) return;
    if (shouldShowModal()) {
      hasOpenedRef.current = true;
      markPromotionModalShown();
      openModal();
    }
  }, [shouldShowModal, openModal]);
  return {
    openModal,
    dismiss,
    isDismissed
  };
};